import React, { useState, useEffect } from "react";
import { Grid, Divider, Typography, IconButton, Tooltip } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { makeStyles } from "@material-ui/core/styles";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from "@material-ui/icons/Delete";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Formik, Form } from "formik";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import Modal_Frame from "../../biztran_controls/Modal_Frame";

let Mode = "Insert", ViewFile = "", FileExt = "", Base64String = null;

const CreateAttachments = (props) => {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [FileMainState, setFileMainState] = useState("initial");
  const [SelectedFile, setSelectedFile] = useState(null);
  const [FileUploaded, setFileUploaded] = useState(0);
  const [AttachID, setAttachID] = useState("");
  const [FileName, setFileName] = useState("");
  const [FileAttName, setFileAttName] = useState("");
  const [FileDes, setFileDes] = useState("");
  const [FileType, setFileType] = useState("");
  const [Count, setCount] = useState(0);
  const [DeleteDisplay, setDeleteDisplay] = useState("none");
  const [ReqLabelFType, setReqLabelFType] = useState("none");
  const [ReqLabelFName, setReqLabelFName] = useState("none");
  const [responseUpload, fetchUploadData] = UseFetchData();
  const [responseDelete, fetchDeleteData] = UseFetchData();
  const [responseViewData, fetchViewData] = UseFetchData();

  const handleUploadClick = (event) => {
    try {
      var file = event.target.files[0];
      var FName = file.name.split(".")[0];
      setFileAttName(FName);
      var FileExtension = file.name.split(".")[1];
      var Base64 = null;
      const reader = new FileReader();
      var url = reader.readAsDataURL(file);
      reader.onloadend = function (e) {
        setSelectedFile([reader.result]);
        Base64 = [reader.result];
        if (FileMainState === "uploaded") {
          setFileUploaded(1);
        }
        FileExt = FileExtension;
        Base64String = Base64;
      };
    } catch (error) {
      console.log(error);
    }
  };

  const EditFileDoc = (Data) => {
    try {
      Mode = "Update";
      setDeleteDisplay("flex");
      setAttachID(Data.id);
      setFileType(Data.AttachmentType);
      setFileAttName(Data.FileName);
      setFileDes(Data.Description);
      ViewFile = Data.FilePath;
      setOpen(true);
    } catch (error) {
      console.log(error);
    }
  };

  const AddFileDoc = () => {
    try {
      Mode = "Insert";
      setDeleteDisplay("none");
      setReqLabelFName("none");
      setReqLabelFType("none");
      setAttachID("");
      setFileType("");
      setFileAttName("");
      setFileDes("");
      ViewFile = "";
      setOpen(true);
    } catch (error) {
      console.log(error);
    }
  };

  const onUploadFile = () => {
    try {
      if (FileAttName !== "") {
        setReqLabelFName("none");
      } else {
        setReqLabelFName("flex");
      }
      // debugger;
      var UserID = sessionStorage.UID;
      var bodyFormData = new FormData();
      bodyFormData.append("Type", FileType);
      bodyFormData.append("Group", props.Group);
      bodyFormData.append("RefDocumentID", props.RefDocumentID);
      bodyFormData.append("FileExtension", FileExt);
      bodyFormData.append("FileName", FileAttName);
      if (Mode === "Insert") {
        bodyFormData.append("AttachmentID", "");
        bodyFormData.append("FileString", Base64String[0].split(",")[1]);
      } else {
        bodyFormData.append("AttachmentID", AttachID);
        if (Base64String !== null) {
          bodyFormData.append("FileString", Base64String[0].split(",")[1]);
        }
      }
      bodyFormData.append("FileDescription", FileDes);
      bodyFormData.append("UserID", UserID);
      fetchUploadData("Activity/Attachment", bodyFormData);
    }
    catch (error) {
      console.log(error);
    }
  };

  const DeleteAttachment = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("PKID", AttachID);
    fetchDeleteData("Activity/DeleteAttachment", bodyFormData);
  };

  const ViewFileOnPage = (FilePath) => {
    debugger;
    window.open(FilePath);
  };

  const PopulateData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("RefDocumentID", props.RefDocumentID);
    //bodyFormData.append("AttachmentType", "File");
    fetchViewData("Activity/GetAttachmentDtls", bodyFormData);
  };

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        renderCell: (params) => (
          <strong>
            {" "}
            <a
              href="javascript:;"
              onClick={() => {
                ViewFileOnPage(params.row.FilePath);
              }}
            >
              <GetAppIcon fontSize="small" />
            </a>{" "}
          </strong>
        ),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 34,
      },
      {
        field: "AttachmentType",
        headerName: "File Type",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 140,
      },
      {
        field: "FileName",
        headerName: "File Name",
        renderCell: (params) => (
          <strong>
            {" "}
            <a
              href="javascript:;"
              onClick={() => {
                EditFileDoc(params.row);
              }}
            >
              {params.row.FileName}
            </a>{" "}
          </strong>
        ),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 148,
      },
      {
        field: "Description",
        headerName: "File Des",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 148,
        renderCell: (params) => (
          <Tooltip title={params.row.Description} >
            <span className="table-cell-trucate">{params.row.Description}</span>
          </Tooltip>
        ),
      },
    ];
    setColumns(gridCols);
    if (responseViewData !== undefined) {
      if (responseViewData.length > 0) {
        setRows(responseViewData);
        setCount(responseViewData.length);
        if (responseViewData[0].FilePath !== "") {
          setReqLabelFName("none");
          setReqLabelFType("none");
          // ViewFile = responseViewData[0].FilePath;
          setAttachID(responseViewData[0].id);
          setFileName(responseViewData[0].FileName);
          setFileMainState("uploaded");
        }
      }
    }
  }, [responseViewData]);

  useEffect(() => {
    // debugger;
    if (responseUpload.Response === true) {
      ViewFile = responseUpload.Message;
      PopulateData();
      setOpen(false);
    } else if (responseUpload.Response === false) {
      alert("Failed.");
    }
  }, [responseUpload]);

  useEffect(() => {
    if (responseDelete.Response === true) {
      PopulateData();
      setOpen(false);
    } else if (responseDelete.Response === false) {
      alert("Failed.");
    }
  }, [responseDelete]);

  useEffect(() => {
    PopulateData();
  }, []);

  // Create a reference to the hidden file input element
  const hiddenFileInput = React.useRef(null);

  // Programatically click the hidden file input element, when the Button component is clicked
  const handleClick = (event) => {
    if (FileType !== "") {
      setReqLabelFType("none");
      hiddenFileInput.current.click();
    } else {
      setReqLabelFType("flex");
    }
  };

  return (
    <div>
      <Typography className={classes.headerCmn} noWrap>
        Attachements({Count})
        <div style={{ width: "100%" }}>
          <div style={{ float: "right", marginTop: -12 }}>
            <Tooltip title="Add Attachement">
              <IconButton onClick={() => { AddFileDoc(); }}>
                <AddCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </Typography>
      <Divider></Divider>
      <div >
        <BiztranControls.DataGrid
          rowHeight={20}
          headerHeight={20}
          rows={rows}
          columns={columns}
          checkboxSelection={false}
          hideFooterPagination={true}
          hideFooter={true}
          Height="160px"
          //Height="250px"
          Width="100%"
        />
      </div>
      <Modal_Frame
        title="File Attachment"
        maxWidth="xs"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <div>
          <Formik
            initialValues={{
              FileType: FileType,
              FileAttName: FileAttName,
              FileDes: FileDes,
            }}
            enableReinitialize
          >
            {(formik) => {
              return (
                <Form>
                  <Grid spacing={1} container>
                    <Grid item xs={12} container direction="row">
                      <Grid item xs={11}>
                        <BiztranControlsFormik
                          control="input"
                          type="text"
                          label="File Type"
                          name="FileType"
                          onChange={(e) => setFileType(e.target.value)}
                        />
                        <label style={{ color: "red", display: ReqLabelFType }}>
                          Required
                        </label>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} container direction="row">
                      <Grid item xs={11}>
                        <BiztranControlsFormik
                          control="input"
                          type="text"
                          label="File Name"
                          name="FileAttName"
                          onChange={(e) => setFileAttName(e.target.value)}
                        />
                        <label style={{ color: "red", display: ReqLabelFName }}>
                          Required
                        </label>
                      </Grid>
                      <Grid item xs={1}>
                        <input
                          type="file"
                          accept=".csv,.xlsx,.xls,.doc,.docx,.pdf"
                          ref={hiddenFileInput}
                          onChange={handleUploadClick}
                          style={{ display: "none" }}
                        />
                        <IconButton
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                          onClick={handleClick}
                          style={{ marginTop: 12 }}
                        >
                          <CloudUploadIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} container direction="row">
                      <Grid item xs={11}>
                        <BiztranControlsFormik
                          control="textarea"
                          type="text"
                          label="File Description"
                          name="FileDes"
                          onChange={(e) => setFileDes(e.target.value)}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ width: "100%" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                          }}
                        >
                          <BiztranControls.Button
                            text="UPLOAD"
                            startIcon={<SaveIcon />}
                            onClick={onUploadFile}
                          />
                          <BiztranControls.Button
                            text="DELETE"
                            onClick={DeleteAttachment}
                            startIcon={<DeleteIcon />}
                            style={{
                              backgroundColor: "red",
                              display: DeleteDisplay,
                            }}
                          />
                          <BiztranControls.Button
                            text="CLOSE"
                            startIcon={<CloseIcon />}
                            onClick={() => {
                              setOpen(false); setReqLabelFName("none"); setReqLabelFType("none");
                            }}
                          />
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal_Frame>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  headerCmn: {
    height: "1.6rem",
    fontSize: "1rem",
    display: "flex",
    flexDirection: "row",
    margin: "0.3rem",
    fontWeight: "bold",
  },
}));

export default CreateAttachments;
